import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";



function About() {
  return (
    <>
    <Header/>
    <main>

      
  {/*===== HERO AREA START =====*/}
  <div
    className="inner-hero"
    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-8 m-auto text-center">
          <div className="inner-main-heading">
            <h1>About Us</h1>
            <div className="breadcrumbs-pages">
              {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>About Us</li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== HERO AREA START =====*/}
       {/*===== ABOUT AREA START =====*/}
      <div className="about20-section-area sp"
       style={{
            backgroundImage: "url(assets/img/bg/2.png)",
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}
       >
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about20-images-area">
          <div className="img1 image-anime reveal">
            <img src="assets/img/about/ashokabout.png" alt="" />
          </div>
          <div className="img2 reveal">
            <img src="assets/img/about/homeabout.png" alt="" />
          </div>
          <img
            src="assets/img/shapes/elements30.png"
            alt=""
            className="elements30"
          />
          <img
            src="assets/img/shapes/elements31.png"
            alt=""
            className="elements31"
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about20-header-area heading24">
          <h5>About Us </h5>
          <div className="space16" />
          <h2 className="text-anime-style-3">
I'M ASHOK NANDA <br></br>  SOCIAL WORKER.
          </h2>
          
         
          <p data-aos="fade-left" data-aos-duration={1000}>
          I am a passionate Indian social activist dedicated to catalyzing positive global transformations. My journey, shaped by diverse roles as an author, entrepreneur, and solid waste management expert, began in Bhubaneswar. I am a graduate of Utkal University and Ravenshaw College, having attended Sainik School. I hold degrees in Law and Philosophy. In 1997, a rural management diploma in the Netherlands broadened my horizons. Deeply connected to Bhubaneswar, I embarked on a mission to effect lasting global change. My diverse experiences and educational background empower me to navigate social complexities with empathy, innovation, and a pursuit of excellence, ushering in a brighter, compassionate future for all.
          </p>
          <div className="space32" />
          <h3 data-aos="fade-left" data-aos-duration={1100}>
            Our Best Service Benefits :
          </h3>
          <div className="space8" />
          <div
            className="list-area"
            data-aos="fade-left"
            data-aos-duration={1200}
          >
            <ul>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Businesses Through Technology Expertise
              </li>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Innovating the Future of Technology
              </li>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Building Smarter Solutions, Together
              </li>
            </ul>
          </div>
        <div className="col-lg-12">
  <div className="space12" />
   <div
                          className="btn-area1 aos-init aos-animate"
                          data-aos="fade-left"
                          data-aos-duration={1200}
                        >
                          <Link to="/Contact" className="theme-btn34">
                            Contact Now <i className="fa-solid fa-arrow-right" />
                          </Link>
                        </div>
</div>

        </div>
      </div>
    </div>
  </div>
</div>




  
  {/*===== ABOUT AREA END =====*/}
  {/*===== COUNTER AREA START =====*/}
       <div className="about14-section sp">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about14-heading heading14">
          <h5 data-aos="fade-left" data-aos-duration={900}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.99935 1.66699C10.3121 1.66699 10.6205 1.68394 10.9243 1.71783C11.0331 1.72986 11.1385 1.76321 11.2344 1.81596C11.3303 1.86871 11.4148 1.93983 11.4832 2.02526C11.5516 2.11069 11.6025 2.20875 11.633 2.31386C11.6635 2.41896 11.6731 2.52905 11.661 2.63783C11.649 2.7466 11.6156 2.85195 11.5629 2.94784C11.5101 3.04373 11.439 3.12829 11.3536 3.1967C11.2682 3.2651 11.1701 3.31601 11.065 3.34652C10.9599 3.37702 10.8498 3.38653 10.741 3.37449C9.36772 3.22086 7.98062 3.49778 6.77158 4.16693C5.56254 4.83608 4.59131 5.8644 3.99224 7.10966C3.39316 8.35491 3.19585 9.75555 3.42759 11.1178C3.65933 12.4801 4.30867 13.7368 5.2858 14.7139C6.26292 15.691 7.51954 16.3403 8.88183 16.5721C10.2441 16.8038 11.6448 16.6065 12.89 16.0074C14.1353 15.4084 15.1636 14.4371 15.8327 13.2281C16.5019 12.0191 16.7788 10.632 16.6252 9.25866C16.6131 9.14988 16.6227 9.0398 16.6532 8.93469C16.6837 8.82959 16.7346 8.73152 16.803 8.64609C16.9411 8.47356 17.1422 8.36297 17.3618 8.33866C17.5815 8.31435 17.8019 8.3783 17.9744 8.51645C18.0598 8.58486 18.131 8.66942 18.1837 8.76531C18.2365 8.86121 18.2698 8.96655 18.2818 9.07533C18.3152 9.37922 18.3321 9.68755 18.3327 10.0003C18.3327 14.6028 14.6018 18.3337 9.99935 18.3337C5.39685 18.3337 1.66602 14.6028 1.66602 10.0003C1.66602 5.39783 5.39685 1.66699 9.99935 1.66699ZM9.97268 6.56449C10.0276 6.77843 9.99534 7.00542 9.883 7.19558C9.77065 7.38575 9.5874 7.52353 9.37352 7.57866C8.78591 7.73259 8.27438 8.09505 7.93438 8.59842C7.59438 9.10178 7.44914 9.71166 7.52577 10.3142C7.60239 10.9168 7.89564 11.4709 8.3508 11.8732C8.80595 12.2754 9.39192 12.4984 9.99935 12.5003C10.5538 12.5006 11.0925 12.3165 11.5309 11.9771C11.9693 11.6377 12.2824 11.1621 12.421 10.6253C12.4801 10.4156 12.6189 10.2374 12.8078 10.1288C12.9967 10.0202 13.2206 9.98992 13.4315 10.0444C13.6425 10.0989 13.8237 10.2338 13.9364 10.4203C14.049 10.6067 14.0842 10.8299 14.0343 11.042C13.7787 12.0219 13.175 12.8753 12.3361 13.4426C11.4972 14.01 10.4805 14.2525 9.47582 14.1249C8.47115 13.9973 7.5473 13.5083 6.87685 12.7493C6.20641 11.9902 5.83524 11.0131 5.83268 10.0003C5.83254 9.07648 6.13943 8.17879 6.70511 7.44839C7.27079 6.71798 8.06318 6.19629 8.95768 5.96533C9.06367 5.93801 9.174 5.93184 9.28238 5.94717C9.39075 5.96249 9.49504 5.99902 9.5893 6.05466C9.68355 6.1103 9.76592 6.18396 9.8317 6.27144C9.89748 6.35892 9.94539 6.4585 9.97268 6.56449ZM15.4193 1.77283C15.5715 1.83589 15.7015 1.94261 15.793 2.0795C15.8845 2.21639 15.9334 2.37733 15.9335 2.54199V4.06699H17.4577C17.6225 4.06703 17.7836 4.11592 17.9206 4.20749C18.0576 4.29906 18.1644 4.4292 18.2274 4.58145C18.2905 4.7337 18.307 4.90122 18.2748 5.06285C18.2427 5.22448 18.1634 5.37295 18.0469 5.48949L15.0993 8.43366C14.9431 8.58995 14.7312 8.67778 14.5102 8.67783H12.4993L10.976 10.202C10.8196 10.3584 10.6076 10.4462 10.3864 10.4462C10.1653 10.4462 9.95322 10.3584 9.79685 10.202C9.64048 10.0456 9.55264 9.83355 9.55264 9.61241C9.55264 9.39127 9.64048 9.17919 9.79685 9.02283L11.321 7.50033V5.48866C11.3211 5.26766 11.4089 5.05574 11.5652 4.89949L14.511 1.95283C14.6276 1.83621 14.7761 1.75679 14.9377 1.7246C15.0994 1.69241 15.267 1.7089 15.4193 1.77199M14.2668 4.55283L12.9877 5.83366V7.01199H14.166L15.446 5.73283H15.1002C14.8792 5.73283 14.6672 5.64503 14.5109 5.48875C14.3546 5.33247 14.2668 5.12051 14.2668 4.89949V4.55283Z"
                fill="#050422"
              />
            </svg>{" "}
            Ambitious
          </h5>
          <div className="space16" />
          <h2 className="text-anime-style-3">
My Journey Of Work And Achievement.          </h2>
          <div className="space16" />
          <p data-aos="fade-left" data-aos-duration={1000}>
   My journey in public service began as a student activist and grew through work with slum communities and people affected by leprosy, earning me recognition as a “Leprosy Worker.” I later led the state leprosy program and contributed to refugee support and charitable work.{" "}
          </p>

          <p data-aos="fade-left" data-aos-duration={1000}>
In 1986, I co-founded Vikash and continued advocating for rights, good governance, and social change. Over four decades, I’ve supported thousands of vulnerable individuals and developed impactful rehabilitation and waste management models that influenced government policies. My mission remains simple: to create meaningful and lasting change.          </p>
          <div className="space32" />
          <div
            className="abotu14-boxarea"
            data-aos="fade-left"
            data-aos-duration={1100}
          >
            <div className="icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={28}
                height={28}
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M14.0007 25.6663C7.55733 25.6663 2.33398 20.4429 2.33398 13.9997C2.33398 7.55635 7.55733 2.33301 14.0007 2.33301C20.4439 2.33301 25.6673 7.55635 25.6673 13.9997C25.6673 20.4429 20.4439 25.6663 14.0007 25.6663ZM12.837 18.6663L21.0866 10.4168L19.4367 8.76685L12.837 15.3665L9.53723 12.0666L7.88731 13.7166L12.837 18.6663Z"
                  fill="#6F00FF"
                />
              </svg>
            </div>
            <div className="textarea14">
              <a href="#">Your Trusted IT Experts Since Day One</a>
              <div className="space16" />
              <p>
                We work with businesses create customized solutions that save
                time, reduce stress, and support long-term.
              </p>
            </div>
          </div>
          <div className="space32" />
          <div
            className="btn-area1"
            data-aos="fade-left"
            data-aos-duration={1200}
          >
            <a href="service.html" className="theme-btn27">
              Explore Our Services
            </a>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about14-images-area">
          <div className="img1" data-aos="zoom-out" data-aos-duration={1000}>
            <img src="/assets/img/about/goal1-1.png" alt="" />
          </div>
          <div className="img2" data-aos="zoom-out" data-aos-duration={1100}>
            <img src="/assets/img/about/goal-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  {/*===== COUNTER AREA END =====*/}
  {/*===== CHOOSE AREA START =====*/}
  
<div className="about23-section sp">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about23-images-area">
          <img
            src="assets/img/others/about23-elements1.png"
            alt=""
            className="about23-elements1"
          />
          <div className="img1 reveal">
            <img src="/assets/img/about/heart-2.png" alt="" />
          </div>
          <div className="img2 text-end reveal">
            <img src="/assets/img/about/heart-1.png" alt="" />
          </div>
          <div
            className="video-buttton23 play-btn"
            href="https://www.youtube.com/watch?v=Y8XpQpW5OVY"
          >
            <a id="play-video" className="video-play-button">
              <span />
            </a>
            <p>Play Intro Video</p>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about23-header heading28">
          {/* <h5 data-aos="fade-left" data-aos-duration={800}>
            <img src="assets/img/icons/span24.svg" alt="" />
            About Us
          </h5> */}
          <div className="space16" />
          <h2 className="text-anime-style-3">
Evolution of Social Influence          </h2>
          <div className="space20" />
          <p data-aos="fade-left" data-aos-duration={1000}>
         In a journey spanning 40 years, my dedication to social causes has touched diverse realms, from aiding leprosy patients to founding non-profit organizations. As an advocate for good governance, I've influenced policies and impacted lives, driven by a relentless passion for positive societal change.
          </p>
          <div className="about-boxarea">
            <div className="row">
              <div
                className="col-lg-6 col-md-6"
                data-aos="zoom-in"
                data-aos-duration={900}
              >
                <div className="box1">
                  <div className="icons">
                    <img src="assets/img/icons/service23-icon1.svg" alt="" />
                  </div>
                  <div className="space16" />
                  <a href="team.html">Meet the Experts Behind Your Success</a>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6"
                data-aos="zoom-in"
                data-aos-duration={1000}
              >
                <div className="box1">
                  <div className="icons">
                    <img src="assets/img/icons/service23-icon2.svg" alt="" />
                  </div>
                  <div className="space16" />
                  <a href="team.html">
                    The Team Behind Your Strategic Advantage
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="space40" />
          <div
            className="btn-area1"
            data-aos="zoom-in"
            data-aos-duration={1200}
          >
            <a href="contact.html" className="theme-btn41">
              Get to Know Us
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  {/*===== CHOOSE AREA END =====*/}
  {/*===== SERVICE AREA START =====*/}
  
  {/*===== SERVICE AREA END =====*/}
  {/*===== TESTIMONIAL AREA START =====*/}
  

  {/*===== TESTIMONIAL AREA END =====*/}
 
  {/*===== CONTACT AREA START =====*/}
  <div className="contact2 sp">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="heading2">
            <div className="contact2-form">
              <span
                className="sub-title"
                data-aos="zoom-in-left"
                data-aos-duration={900}
              >
                <img src="assets/img/icons/span3.svg" alt="" />
                CONTACT US{" "}
              </span>
              <h2 className="text-anime-style-3">Lets Work Together</h2>
              <p
                className="mt-16"
                data-aos="fade-right"
                data-aos-duration={900}
              >
                eady to take your social media presence to the next level? Let’s
                work together to create impactful strategies drive engagement,
                growth, and success for your brand.
              </p>
              <form action="#" data-aos="fade-right" data-aos-duration={1000}>
                <div className="row mt-16">
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="text" placeholder="First Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="text" placeholder="Last Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="email" placeholder="Email Address" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-input">
                      <input type="number" placeholder="Phone Number" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="single-input">
                      <select className="wide">
                        <option value={1}>Service Type</option>
                        <option value={2}>Option 1</option>
                        <option value={3}>Option 2</option>
                        <option value={4}>Option 3</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="single-input">
                      <textarea
                        rows={5}
                        placeholder="How can we help you?"
                        defaultValue={""}
                      />
                    </div>
                    <div className="button mt-30">
                      <button className="theme-btn3" type="submit">
                        Send{" "}
                        <span className="arrow1">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                        <span className="arrow2">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="contact2-image image-anime reveal ml-40 md:ml-0 sm:ml-0 md:mt-30 sm:mt-30">
            <img
              className="w-full"
              src="assets/img/others/contact2-image.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== CONTACT AREA END =====*/}
</main>

<Footer/>
    </>
  );
}

export default About;
